module.exports = __webpack_public_path__ + "static/featured_hero_s-677f2cfc40b440e501919b50bf480379.mp4";